export const apiUrl = process.env.REACT_APP_API_URL;
console.log("API URL:", apiUrl);

const ApplicantAPIService = {};
export default ApplicantAPIService;
